"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMiniProfileHighlightDetails = exports.StyledMiniProfileHighlightSubtitle = exports.StyledMiniProfileHighlightTitleNoTruncate = exports.StyledMiniProfileHighlightTitleTruncate = exports.StyledMiniProfileHighlightTitle = exports.StyledMiniProfileHighlight = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnSpreads = _interopRequireDefault(require("UIComponents/column/UIColumnSpreads"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* So that links in the mini highlight are truncated */\n  a {\n    display: flex;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  vertical-align: middle;\n  display: block;\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-inline-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-height: 1.5rem;\n  max-height: 2.75rem;\n  vertical-align: middle;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  line-height: ", ";\n  margin-bottom: 0;\n  vertical-align: middle;\n  display: block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  overflow-x: hidden;\n  flex-grow: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledMiniProfileHighlight = (0, _styledComponents.default)(_UIColumn.default).withConfig({
  displayName: "StyledMiniProfileHighlight",
  componentId: "ce4wto-0"
})(_templateObject());
exports.StyledMiniProfileHighlight = StyledMiniProfileHighlight;
var StyledMiniProfileHighlightTitle = (0, _styledComponents.default)(function (_ref) {
  var __hasSubtitle = _ref.hasSubtitle,
      props = (0, _objectWithoutProperties2.default)(_ref, ["hasSubtitle"]);
  return _react.default.createElement(_H.default, props);
}).withConfig({
  displayName: "StyledMiniProfileHighlight__StyledMiniProfileHighlightTitle",
  componentId: "ce4wto-1"
})(_templateObject2(), function (_ref2) {
  var hasSubtitle = _ref2.hasSubtitle;
  return hasSubtitle ? '1.2rem' : '2.75rem';
});
exports.StyledMiniProfileHighlightTitle = StyledMiniProfileHighlightTitle;
var StyledMiniProfileHighlightTitleTruncate = (0, _styledComponents.default)(StyledMiniProfileHighlightTitle).withConfig({
  displayName: "StyledMiniProfileHighlight__StyledMiniProfileHighlightTitleTruncate",
  componentId: "ce4wto-2"
})(_templateObject3());
/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */

exports.StyledMiniProfileHighlightTitleTruncate = StyledMiniProfileHighlightTitleTruncate;
var StyledMiniProfileHighlightTitleNoTruncate = (0, _styledComponents.default)(StyledMiniProfileHighlightTitle).withConfig({
  displayName: "StyledMiniProfileHighlight__StyledMiniProfileHighlightTitleNoTruncate",
  componentId: "ce4wto-3"
})(_templateObject4());
/* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */

exports.StyledMiniProfileHighlightTitleNoTruncate = StyledMiniProfileHighlightTitleNoTruncate;

var StyledMiniProfileHighlightSubtitle = _styledComponents.default.span.withConfig({
  displayName: "StyledMiniProfileHighlight__StyledMiniProfileHighlightSubtitle",
  componentId: "ce4wto-4"
})(_templateObject5());

exports.StyledMiniProfileHighlightSubtitle = StyledMiniProfileHighlightSubtitle;
var StyledMiniProfileHighlightDetails = (0, _styledComponents.default)(_UIColumnSpreads.default).withConfig({
  displayName: "StyledMiniProfileHighlight__StyledMiniProfileHighlightDetails",
  componentId: "ce4wto-5"
})(_templateObject6());
exports.StyledMiniProfileHighlightDetails = StyledMiniProfileHighlightDetails;